export default __webpack_public_path__ + "static/media/team2.c62b8b47.png";